import { SVGIconComponent } from './types';

export const ProjectTypeNetwork: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, ...style }}
    className={className}
  >
    <path
      fill="currentColor"
      d="M17.182 0c.452 0 .818.366.818.818v7.364a.82.82 0 0 1-.24.579l-9 9a.82.82 0 0 1-1.157 0L.24 10.397a.82.82 0 0 1 0-1.158l9-9A.82.82 0 0 1 9.82 0zM9.818 4.09a.82.82 0 0 0-.675.357l-.99 1.443-1.679.496a.82.82 0 0 0-.417 1.283l1.068 1.388-.048 1.75a.816.816 0 0 0 1.092.793l1.65-.586 1.649.586a.817.817 0 0 0 1.092-.793l-.048-1.75 1.067-1.388a.818.818 0 0 0-.417-1.283l-1.679-.496-.99-1.443a.82.82 0 0 0-.675-.356"
    />
  </svg>
);
